export const GAME_SCROLL_SAVE_REQUEST = 'GAME_SCROLL_SAVE_REQUEST';
export const GAME_SCROLL_SAVE_SUCCESS = 'GAME_SCROLL_SAVE_SUCCESS';
export const GAME_SCROLL_USE_REQUEST = 'GAME_SCROLL_USE_REQUEST';
export const GAME_SCROLL_CLEAR = 'GAME_SCROLL_CLEAR';
